(function () {
  const BODY_CHROME_HIDDEN_CLASS = 'spring-pre-nav-chrome-hidden';

  const TOP_CHROME_SECTION_SELECTORS = [
    '#shopify-section-announcement',
    '#shopify-section-announcement-special-page',
    '#shopify-section-experience-announcement',
  ];

  function resolveTarget(targetId) {
    if (!targetId) return null;

    let el = document.getElementById(targetId);
    if (el) return el;

    el = document.querySelector(`[id$="__${targetId}"]`);
    if (el) return el;

    el = document.querySelector(`[id$="${targetId}"]`);
    if (el) return el;

    return null;
  }

  function getElementTop(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.getElementById('spring-sale-pre-nav');
    if (!nav) return;

    const revealOnScroll = nav.getAttribute('data-reveal-on-scroll') === 'true';
    const revealTriggerId = (nav.getAttribute('data-reveal-trigger') || '').trim();
    const navSectionWrap = nav.closest('.shopify-section');
    const navItems = nav.querySelectorAll('.nav-wrapper .nav');
    const header = document.querySelector('.site-header');
    const headerSectionWrap = header ? header.closest('.shopify-section') || header : null;
    const sections = [];
    let scrollLockUntil = 0;
    let scrollEndTimer = null;
    let revealTriggerEl = null;
    let pinLockUntil = 0;
    // null = unknown, so the first sync always writes the real state (self-heals bfcache leftovers)
    let chromeHidden = null;

    // Chrome (announcements + header) that must leave layout/hit-testing while the nav is stuck
    const chromeEls = (() => {
      const els = [];
      if (headerSectionWrap) els.push(headerSectionWrap);
      TOP_CHROME_SECTION_SELECTORS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => els.push(el));
      });
      return els;
    })();

    const measureTopChromeHeight = () => {
      if (document.body.classList.contains(BODY_CHROME_HIDDEN_CLASS)) return 0;

      let total = 0;
      TOP_CHROME_SECTION_SELECTORS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          total += el.offsetHeight;
        });
      });

      if (header) {
        total += header.offsetHeight;
      }

      return total;
    };

    const syncChromeHidden = (hidden) => {
      const next = Boolean(hidden);
      if (next === chromeHidden) return;
      chromeHidden = next;

      document.body.classList.toggle(BODY_CHROME_HIDDEN_CLASS, next);

      // inert removes the header from hit-testing entirely, so the nav tabs are
      // never covered by the (visually hidden but still stacked) header.
      chromeEls.forEach((el) => {
        if (next) {
          el.setAttribute('inert', '');
        } else {
          el.removeAttribute('inert');
        }
      });
    };

    // Fixed path (default): the bar is pinned with position:fixed, the section wrapper
    // keeps its flow slot through --spring-pre-nav-slot-height so nothing shifts.
    const syncSlotHeight = () => {
      if (revealOnScroll || !navSectionWrap) return;
      const next = nav.offsetHeight ? `${nav.offsetHeight}px` : '0px';
      if (navSectionWrap.style.getPropertyValue('--spring-pre-nav-slot-height') !== next) {
        navSectionWrap.style.setProperty('--spring-pre-nav-slot-height', next);
      }
    };

    // Pinned = the page has scrolled past the nav's slot in the flow
    const isNavPinned = () => (navSectionWrap || nav).getBoundingClientRect().top <= 0.5;

    // The nav also has to win while its top edge is still inside the header band
    // (e.g. right after an anchor jump), otherwise the fixed header keeps sitting
    // on the nav and swallows clicks on the first tab.
    const isNavInHeaderBand = () => {
      const rect = (navSectionWrap || nav).getBoundingClientRect();
      if (rect.bottom <= 0) return false;

      const headerHeight = header ? header.offsetHeight : 0;
      return rect.top < headerHeight;
    };

    const syncPinnedState = () => {
      if (revealOnScroll) return;
      syncSlotHeight();
      // pinLock keeps the bar pinned while a nav click is still smooth-scrolling
      const stuck = isNavPinned() || Date.now() < pinLockUntil;
      nav.classList.toggle('is-stuck', stuck);
      syncChromeHidden(stuck || isNavInHeaderBand());
    };

    // Reveal path keeps fixed + slide-in (no sticky)
    function setRevealVisible(visible) {
      const wasVisible = nav.classList.contains('is-visible');
      if (wasVisible === visible) return;

      nav.classList.toggle('is-visible', visible);
      syncChromeHidden(visible);
    }

    function getNavOffset() {
      return nav.offsetHeight;
    }

    function getViewportMarker() {
      if (revealOnScroll) {
        const isVisible = nav.classList.contains('is-visible');
        const navHeight = isVisible ? nav.offsetHeight : 0;
        const hHeight = isVisible ? 0 : measureTopChromeHeight();
        return hHeight + navHeight;
      }

      if (isNavPinned()) {
        return getNavOffset();
      }
      return measureTopChromeHeight() + nav.offsetHeight;
    }

    function scrollSectionIntoView(sectionEl) {
      if (revealOnScroll) {
        const marker = getViewportMarker();
        const sectionTop = getElementTop(sectionEl);
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const targetScroll = Math.max(0, Math.min(sectionTop - marker, maxScroll));

        window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
        });
        return;
      }

      // Fixed bar: the slot keeps the page height stable, the target is offset by the bar
      syncSlotHeight();
      syncChromeHidden(true);
      pinLockUntil = Date.now() + 1000;
      nav.classList.add('is-stuck');
      void nav.offsetHeight;

      const marker = getNavOffset();
      const sectionTop = getElementTop(sectionEl);
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const targetScroll = sectionTop - marker;

      window.scrollTo({
        top: Math.max(0, Math.min(targetScroll, maxScroll)),
        behavior: 'smooth',
      });
    }

    // Shared by mask / other in-page jumps so offset matches nav clicks
    window.springSalePreNavScrollTo = (target) => {
      const el = typeof target === 'string' ? resolveTarget(target.replace(/^#/, '')) || document.querySelector(target) : target;
      if (!el) return false;
      if (revealOnScroll) {
        setRevealVisible(true);
        void nav.offsetHeight;
      }
      scrollSectionIntoView(el);
      return true;
    };

    function updateRevealFromViewport() {
      if (!revealOnScroll || !revealTriggerEl) return;
      const bottom = revealTriggerEl.getBoundingClientRect().bottom;
      setRevealVisible(bottom <= 0);
    }

    function recalcRevealTrigger() {
      if (!revealOnScroll) return;

      const matched = resolveTarget(revealTriggerId);
      revealTriggerEl = matched ? matched.closest('.shopify-section') || matched : null;
    }

    function setActiveNav(targetId) {
      navItems.forEach((item) => {
        item.classList.toggle('active', item.getAttribute('data-section') === targetId);
      });
    }

    function updateActiveNav() {
      if (Date.now() < scrollLockUntil) return;
      if (!sections.length) return;

      const marker = getViewportMarker();
      let currentId = sections[0].id;

      sections.forEach((section) => {
        if (section.el.getBoundingClientRect().top <= marker + 1) {
          currentId = section.id;
        }
      });

      setActiveNav(currentId);
    }

    function lockScrollSpy(ms) {
      scrollLockUntil = ms ? Date.now() + ms : Number.POSITIVE_INFINITY;
    }

    function onScrollEnd() {
      scrollLockUntil = 0;
      updateActiveNav();
    }

    function onScroll() {
      if (revealOnScroll) {
        updateRevealFromViewport();
      } else {
        syncPinnedState();
      }

      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(onScrollEnd, 120);

      updateActiveNav();
    }

    if (revealOnScroll) {
      recalcRevealTrigger();
      // nav starts hidden in reveal mode -> chrome must be visible
      syncChromeHidden(false);
    }

    window.addEventListener('resize', () => {
      if (revealOnScroll) {
        recalcRevealTrigger();
      } else {
        syncPinnedState();
      }
      updateActiveNav();
    });

    navItems.forEach((item) => {
      const targetId = item.getAttribute('data-section');
      const el = resolveTarget(targetId);
      if (el) {
        sections.push({ id: targetId, el });
      }
    });

    sections.sort((a, b) => getElementTop(a.el) - getElementTop(b.el));

    navItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        const navTargetId = item.getAttribute('data-section');
        let scrollTargetId = navTargetId;

        if (scrollTargetId === 'hot-sale') {
          scrollTargetId = window.innerWidth < 768 ? 'hot-sale-nav' : 'hot-sale';
        }

        const sectionRoot = resolveTarget(scrollTargetId);

        if (sectionRoot) {
          if (revealOnScroll) {
            setRevealVisible(true);
            void nav.offsetHeight;
          }

          lockScrollSpy(800);
          setActiveNav(navTargetId);
          scrollSectionIntoView(sectionRoot);
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(onScrollEnd, 1000);

          if (window.dataLayer) {
            window.dataLayer.push({ event_parameters: null });
            window.dataLayer.push({
              event: 'ga4Event',
              event_name: 'select_content_category',
              event_parameters: {
                button_name: item.textContent?.trim(),
                content_type: 'navbar',
              },
            });
          }
        }
      });
    });

    if (!revealOnScroll) {
      syncSlotHeight();
      if (window.ResizeObserver) {
        // fonts / breakpoint changes alter the bar height -> keep the slot in sync
        const slotObserver = new ResizeObserver(syncSlotHeight);
        slotObserver.observe(nav);
      }
      document.fonts?.ready.then(syncSlotHeight);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    updateActiveNav();
  });
})();
